<template>
  <ul class="navList" v-if="footerNav">
    <li
        class="nav_item"
        @click.prevent="tabChange(vo)"
        v-for="(vo,i) in footerNav.data"
        :style="[{width: 100 / footerNav.data.length + '%'},{color:vo.checked ? footerNav.checkedColor : defaultColor}]"
    >
      <i class="iconfont" :class="vo.icon"></i>
      <span class="nav_name">{{ vo.title }}</span>
    </li>
  </ul>
</template>

<script>
import {mapState} from 'vuex'
import {Notify} from 'vant'
import Bus from "@/utils/Bus";
export default {
  name: "Footer_nav",
  data() {
    return {
      defaultColor: '#999',
      p_org: ''
    }
  },
  created() {
    const orgid = this.getQueryData('orgId') || this.getQueryData('orgid') || this.getQueryData('org_id')
    //const orgid = window.location.search.substring(1).split('=')[1] || ''
    this.$store.commit('SETORGID', orgid)
  },
  mounted() {
    this.getLocations().then(res => {
      const data = {type: 'all', oid: this.orgId, longitude: res.lng, latitude: res.lat}
      let formData = new FormData()
      Object.keys(data).forEach((key) => {
        formData.append(key, data[key])
      })
      this.$ajax('/Home/StoresList/getStores', formData, 'POST')
          .then(res => {
            if (res.status === 1) {
              if (!res.orgs) this.$router.replace({name:'error'})
              this.p_org = res.p_org_id
              this.$store.commit('GETSTORES', {orgs:res.orgs,p_org_id:res.p_org_id})
              if (!localStorage.getItem(`new_${res.p_org_id}`)) {
                this.$store.commit('CHANGESTOREMODELSTATUS', true)
              } else {
                this.getHomeData()
              }
            }
          })
    })
  },
  methods: {
    getQueryData(variable){
      let query = window.location.search.substring(1)
      let vars = query.split("&")
      for (var i=0;i<vars.length;i++) {
        var pair = vars[i].split("=");
        if(pair[0] == variable){return pair[1];}
      }
      return(false);
    },
    tabChange(vo) {
      vo.jumpLink.indexOf('http') === 0 ? window.location.href = vo.jumpLink : this.$router.push({path:vo.jumpLink})
      if(vo.type === 'home'){
        let url = document.location.href
        this.wxShare.wxShowMenu('/Home/TinyWebsite/index_share',{org_id:this.orgId,url},true)
      }
    },
    getLocations() {
      return new Promise((resolve, reject) => {
        const locationCity = new BMap.Geolocation();
        locationCity.getCurrentPosition(function (point) {
          resolve(point)
        })
      })
          .then(res => {
            localStorage.setItem('location', JSON.stringify({lng: res.longitude, lat: res.latitude,}))
            if (window.location.href.indexOf('home') === -1){
              localStorage.setItem(`new_${this.orgId}`,this.orgId)
              this.$ajax("/Home/TinyWebsite/org",{org_id:this.orgId,longitude:res.longitude,latitude:res.latitude}).then(res=>{
                Bus.$emit('getIns',res.data.org_name)
                this.$store.commit('GERORG',res)
              })
            }
            return {lng: res.longitude, lat: res.latitude}
          })
    },
    //获取home数据
    getHomeData() {
      this.$store.commit('CHANGELOADING', true)
      const location = JSON.parse(localStorage.getItem('location'))
      const org_id = localStorage.getItem(`new_${this.orgId}`)
      this.$store.dispatch('getViewData', {org_id, longitude: location.lng, latitude: location.lat}).then(() => {
        this.$store.commit('CHANGELOADING', false)
        //this.$router.push({name: 'home'})
        this.$store.commit('FOOTERNAVCHECKED',window.location.href)
      })
    }
  },
  computed: {
    ...mapState({
      org: state => state.org.org_id,
      footerNav: state => state.footer_nav,
      orgId: state => state.orgId,
    })
  },
  components: {[Notify.name]: Notify}
}
</script>

<style lang="stylus" scoped>
@import "../static/css/global.styl";
.navList {
  width: 100%;
  height: 60px;
  display: flex;
  box-shadow: $shadow;
  background: #fff;
  border-top: 1px solid rgba(0, 0, 0, .1);
  position: fixed;
  bottom: 0
  z-index 100
}

.nav_item {
  width: 20%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #999
}

.iconfont {
  font-size: 22px;
  margin-bottom: 2px
}

&.active {
  color: $bgColor
}

.nav_name {
  font-size: 12px
}
</style>
